import React from 'react';
import { FileTextIcon, ClipboardIcon, PieChartIcon, ClockIcon } from 'lucide-react';
import { MetricCard } from '../components';
export const MetricsRow = ({ dashboardData, formatCompletionTime }) => {
    return (React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6" },
        React.createElement(MetricCard, { title: "Total Forms", value: dashboardData.totalForms, icon: React.createElement(FileTextIcon, { className: "w-5 h-5" }), trend: {
                value: dashboardData.formsIncrease === 0 ? '' : `+${Math.abs(dashboardData.formsIncrease)} new`,
                positive: true
            }, iconBgColor: "bg-indigo-100", iconColor: "text-indigo-600" }),
        React.createElement(MetricCard, { title: "Total Submissions", value: dashboardData.totalSubmissions, icon: React.createElement(ClipboardIcon, { className: "w-5 h-5" }), trend: {
                value: dashboardData.submissionsIncrease === 0 ? '' : `+${Math.abs(dashboardData.submissionsIncrease)} new`,
                positive: true
            }, iconBgColor: "bg-orange-100", iconColor: "text-orange-600" }),
        React.createElement(MetricCard, { title: "Completion Rate", value: `${dashboardData.completionRate.toFixed(1)}%`, icon: React.createElement(PieChartIcon, { className: "w-5 h-5" }), trend: {
                value: '',
                // value: "+4% increase",
                positive: true
            }, iconBgColor: "bg-emerald-100", iconColor: "text-emerald-600" }),
        React.createElement(MetricCard, { title: "Avg. Completion Time", value: formatCompletionTime(dashboardData.avgCompletionTime), icon: React.createElement(ClockIcon, { className: "w-5 h-5" }), trend: {
                value: '',
                // value: "-15s faster",
                positive: true
            }, iconBgColor: "bg-violet-100", iconColor: "text-violet-600" })));
};
export default MetricsRow;
